import ReactGA from 'react-ga4';

const isProduction = process.env.NODE_ENV === 'production';
const GA4_ID = process.env.REACT_APP_GA4_ID;

export const initGA = () => {
  if (isProduction && GA4_ID && process.env.REACT_APP_ENABLE_ANALYTICS === 'true') {
    ReactGA.initialize(GA4_ID, {
      gaOptions: {
        anonymizeIp: true, // COPPA compliance
      },
    });
  }
};

export const logPageView = (path) => {
  if (isProduction && GA4_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const logEvent = (category, action, label = null, value = null) => {
  if (isProduction && GA4_ID) {
    const eventParams = {
      category,
      action,
    };
    
    if (label) eventParams.label = label;
    if (value !== null) eventParams.value = value;
    
    ReactGA.event(eventParams);
  }
};

// Custom events for your app
export const trackLogin = (role) => {
  logEvent('Auth', 'Login', role); // role as label
};

export const trackTaskComplete = (taskId) => {
  logEvent('Tasks', 'Complete', taskId); // taskId as label
};

export const trackRewardRedeem = (rewardValue) => {
  logEvent('Rewards', 'Redeem', null, rewardValue); // rewardValue as value (4th param)
};

export const trackAffiliateClick = (productName) => {
  logEvent('Affiliate', 'Click', productName);
};
